import { render, staticRenderFns } from "./ChartSectionComponent.vue?vue&type=template&id=70815af6"
import script from "./ChartSectionComponent.vue?vue&type=script&lang=js"
export * from "./ChartSectionComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports